// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  /* Always 5 cards in a row */
  gap: 10px;
  margin-top: 15px;
  /* padding: 16px; */
  width: 100%;

}

/* Card Styling */
.card {
  text-align: center;
  /* padding: 16px; */
  border: 1px solid;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #ffff;

}

/* Text and Button Styling */
.card-text {
  font-weight: 600;
  font-size: 15px;
  /* margin-top: 5px; */
  color: #4299db;
}

.card-title {
  /* font-weight: bold; */
  font-size: 25px;
  /* margin-top: 5px; */

}

.card-btn {
  width: 100%;
  color: white;
  font-weight: 600;
  font-size: 14px;
  border: none;
  padding: 5px;
  cursor: pointer;
  margin-top: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

/* Responsive Adjustments */
@media (max-width: 1000px) {
  .card-container {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 750px) {
  .card-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* //welcome home panel */
/* Admin Dashboard Card */
.welcome-card {
background-color: #95a8ed;
/* color: #4299db; */
padding: 15px;
}

.admin-dashboard-card {
  /* border-radius: 8px; */
  /* padding: 16px; */
  background-color: #ffff;
}

/* Title */
.admin-dashboard-title {
  color: rgb(40, 46, 231) !important ;

  /* font-weight: bold; */
}

/* Subtitle */
.admin-dashboard-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: rgb(40, 46, 231);
}

/* Avatar Section */
.admin-dashboard-avatar-section {
  padding: 20px;
  display: flex;
  text-align: center;
  /* margin-top: 20px; */
  justify-content: space-evenly;

}
.avtr-admin{

  /* border-radius: 50%; */
}
/* Avatar */
.admin-dashboard-avatar {
  margin-top: -40px;
  border: 2px solid #ffff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
}

/* Admin Name */
.admin-dashboard-name {
  margin-top: 10px;
  font-weight: bold;
}

/* User Stats */
.admin-dashboard-stats {
  display: flex;
  justify-content: space-between;
  padding: 5px;
}

/* User Stats Text */
.admin-dashboard-stats-text {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: block;
  /* Places each item on a new line */
  margin-bottom: 5px;
}

/* / total bid amount css */
/* Card Styling */
.dashboard-card {
  /* border-style: dashed; */
  border-radius: 8px;

  margin-top: 20px;
}

.dashboard-card-inner {
  padding: 6px;
  border: 1px;
  /* border-radius: 8px; */
  border-style: dashed;
  border-color: rgb(74, 71, 71);
  margin-bottom: 2px;
}

.dashboard-card-row {
  display: flex;
  /* border-radius: 8px;
  border-color: rgb(74, 71, 71); */

  justify-content: space-between;
  align-items: center;
}

.dashboard-card-col {
  /* flex: 1; */
  font-weight: 600;
}

.dashboard-card-value {
  /* border-radius: 8px; */

  margin-right: 10px;
  font-weight: bold;
}

/* Profit Card Styling */
.profit-card {
  border: 1px;
  /* border-radius: 8px; */
  /* border-color: rgb(74, 71, 71); */

  /* padding: 5px; */
  margin-bottom: 40px;
  background-color: #349163;
  color: white;

}




/* Force desktop layout when "Desktop Site" is enabled */
@media (min-width: 1024px),
(orientation: landscape) {
  .card-container {
    grid-template-columns: repeat(5, 1fr) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;;AAEb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;;AAEzB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,qBAAqB;;AAEvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,yBAAyB;AACzB,yBAAyB;AACzB;AACA,yBAAyB;AACzB,oBAAoB;AACpB,aAAa;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,mCAAmC;;EAEnC,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;;AAE/B;AACA;;EAEE,wBAAwB;AAC1B;AACA,WAAW;AACX;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb;kCACgC;;EAEhC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;;EAExB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,wBAAwB;EACxB,mCAAmC;;EAEnC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;;AAEd;;;;;AAKA,wDAAwD;AACxD;;EAEE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".card-container {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  /* Always 5 cards in a row */\n  gap: 10px;\n  margin-top: 15px;\n  /* padding: 16px; */\n  width: 100%;\n\n}\n\n/* Card Styling */\n.card {\n  text-align: center;\n  /* padding: 16px; */\n  border: 1px solid;\n  border-radius: 5px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  background-color: #ffff;\n\n}\n\n/* Text and Button Styling */\n.card-text {\n  font-weight: 600;\n  font-size: 15px;\n  /* margin-top: 5px; */\n  color: #4299db;\n}\n\n.card-title {\n  /* font-weight: bold; */\n  font-size: 25px;\n  /* margin-top: 5px; */\n\n}\n\n.card-btn {\n  width: 100%;\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border: none;\n  padding: 5px;\n  cursor: pointer;\n  margin-top: 4px;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 1000px) {\n  .card-container {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (max-width: 750px) {\n  .card-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* //welcome home panel */\n/* Admin Dashboard Card */\n.welcome-card {\nbackground-color: #95a8ed;\n/* color: #4299db; */\npadding: 15px;\n}\n\n.admin-dashboard-card {\n  /* border-radius: 8px; */\n  /* padding: 16px; */\n  background-color: #ffff;\n}\n\n/* Title */\n.admin-dashboard-title {\n  color: rgb(40, 46, 231) !important ;\n\n  /* font-weight: bold; */\n}\n\n/* Subtitle */\n.admin-dashboard-subtitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: rgb(40, 46, 231);\n}\n\n/* Avatar Section */\n.admin-dashboard-avatar-section {\n  padding: 20px;\n  display: flex;\n  text-align: center;\n  /* margin-top: 20px; */\n  justify-content: space-evenly;\n\n}\n.avtr-admin{\n\n  /* border-radius: 50%; */\n}\n/* Avatar */\n.admin-dashboard-avatar {\n  margin-top: -40px;\n  border: 2px solid #ffff;\n  border-radius: 50%;\n  width: 80px;\n  height: 80px;\n}\n\n/* Admin Name */\n.admin-dashboard-name {\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n/* User Stats */\n.admin-dashboard-stats {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px;\n}\n\n/* User Stats Text */\n.admin-dashboard-stats-text {\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  display: block;\n  /* Places each item on a new line */\n  margin-bottom: 5px;\n}\n\n/* / total bid amount css */\n/* Card Styling */\n.dashboard-card {\n  /* border-style: dashed; */\n  border-radius: 8px;\n\n  margin-top: 20px;\n}\n\n.dashboard-card-inner {\n  padding: 6px;\n  border: 1px;\n  /* border-radius: 8px; */\n  border-style: dashed;\n  border-color: rgb(74, 71, 71);\n  margin-bottom: 2px;\n}\n\n.dashboard-card-row {\n  display: flex;\n  /* border-radius: 8px;\n  border-color: rgb(74, 71, 71); */\n\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dashboard-card-col {\n  /* flex: 1; */\n  font-weight: 600;\n}\n\n.dashboard-card-value {\n  /* border-radius: 8px; */\n\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n/* Profit Card Styling */\n.profit-card {\n  border: 1px;\n  /* border-radius: 8px; */\n  /* border-color: rgb(74, 71, 71); */\n\n  /* padding: 5px; */\n  margin-bottom: 40px;\n  background-color: #349163;\n  color: white;\n\n}\n\n\n\n\n/* Force desktop layout when \"Desktop Site\" is enabled */\n@media (min-width: 1024px),\n(orientation: landscape) {\n  .card-container {\n    grid-template-columns: repeat(5, 1fr) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
